<template>
  <div class="tw-shadow">
    <b-card no-body class="tw-h-full tw-w-full tw-p-0 tw-m-0" v-if="ready">
      <b-tabs card fill>
        <b-tab v-for="(tab, key) in data" :title="key" :key="key" :active="key === defaultSelected">

          <h6 class="tw-font-bolder tw-mb-0">Ento </h6>
          <!-- <span class="text-secondary tw-text-xs">{{ tab.chartdata.datasets[0].data[0] }} Infected in total</span> -->
          <p class="text-secondary tw-text-xs">{{ total_ento }} Total Number Collected</p>
          <doughnut-chart class="k-test" :chartdata="tab.chartdata" :options="tab.options"></doughnut-chart>
          <div id="enrollment-label" style="margin-top: 0em">
            <h1 class="tw-text-4xl tw-font-bolder text-center tw-mb-0">{{ total_ento }}</h1>
            <h5 class="tw-font-bolder text-center">Total Number Collected</h5>
          </div>

          <div class="text-right">
            <!-- <b-button :to="{ name: 'metrics-subject-infected-details'}" variant="outline-secondary">More</b-button> -->
            <div style="padding: 1.15em" />
          </div>
        </b-tab>
      </b-tabs>
      <div class="tw-mt-auto tw-flex tw-justify-end">
        <info-popover>
          <template v-slot:title>Ento</template>
          <p>Ento result from light trap collection</p>
        </info-popover>
      </div>
    </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DoughnutChart from "@/components/charts/DoughnutChart.vue";

import * as _ from 'lodash';

export default {
  mixins: [],
  components: {
    DoughnutChart
  },
  props: {},
  data: function() {
    return {
      ready: false,
      // trigger point for the ET is 658
      trigger_point: 658,
      chartdata: {
        datasets: [],
        labels: ["Eave Tubes", " Control"]
      },
      defaultSelected: "Cohort",
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutoutPercentage: 65,
        circumference: Math.PI,
        rotation: -Math.PI,
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 18
          }
        },
        title: {
          display: false,
          text: "Enrolled Subjects"
        },
        tooltips: {
          bodyFontSize: 14
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      },
      data: {}
    };
  },
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      const that = this;

      const params = {};

      // use the same API with enrollment chart
      HTTP.get("/eavetubes/metrics/positive-infections-chart/", { params: params })
        .then((response) => {

        that.total_ento = response.data.total_ento;

        // three values such as ET, Control, and upto the trigger point
        const chartData = {"Cohort": [
          response.data.et_ento,
          response.data.control_ento,
        ]}

        _.each(chartData, (val, key) => {
          that.data[key] = {
            id: key.replace(' ', '-'),
            chartdata: _.cloneDeep(that.chartdata),
            options: _.cloneDeep(that.options)
          };

          that.data[key].chartdata.datasets.push(
            {
                data: val,
                backgroundColor: ["#37B1CA", "#EB513E"]
            }
          );
        });

        that.ready = true;

      }).catch((error) => {
          HandleErrors.HandleErrors(error);
      });
    },
    percentRetained: function(chartdata) {
      let val = _.round((chartdata.datasets[0].data[0] / (chartdata.datasets[0].data[0] + chartdata.datasets[0].data[1])) * 100, 2);
      return _.isNaN(val) ? 0 : val;
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {}
  }
};
</script>

<style>
#enrollment-label {
  position: absolute;
  top: 68%;
  left: 50%;
  transform: translate(-50%, -50%);
}
nav.card-header {
  border-bottom: none;
  padding: 0.5rem 0 0 0;
}
ul.nav.nav-tabs {
  padding: 0 .5rem;
}
ul.nav.nav-tabs li.nav-item {
  font-size: 0.7rem;
}
ul.nav.nav-tabs a.nav-link {
  padding: .35rem .5rem;
}
</style>